import $ from 'jquery';
import grecaptcha from 'grecaptcha';

const recaptchaInputName = 'recaptcha_token';
// Il faut ajouter l'identifiant des formulaires de connexion s�curis�s par Google Recaptcha dans cette liste
const securedFormIds = [
  '#LoginForm2',
  '#LoginForm3',
  '#postuler_offre',
  '#js-login-postuler-form',
  '#loginForm',
  '#confirmationLdapForm'
];
const recaptchaScript = $('#recaptcha-script');
// Pour �viter de casser le js lorsque le script n'est pas import� dans la page
const recaptchaSiteKey =
  recaptchaScript.length > 0
    ? recaptchaScript
        .attr('src')
        .split('?')[1]
        .substr('render='.length)
    : null;

const createInput = function(token) {
  // Creation d'un champs invisible
  return $('<input>').attr({
    type: 'hidden',
    class: recaptchaInputName,
    name: recaptchaInputName,
    value: token
  });
};

export default {
  getToken: function(actionName) {
    return grecaptcha.execute(recaptchaSiteKey, { action: actionName });
  },
  initAsyncOnSubmit: function(actionName) {
    grecaptcha.ready(function() {
      // Override du comportement de la soumission du formulaire en HTML
      $(securedFormIds.join(',')).submit(function(e) {
        e.preventDefault();
        const form = $('#' + e.target.id);
        grecaptcha
          .execute(recaptchaSiteKey, { action: actionName })
          .then(function(token) {
            // G�n�ration/remplacement du token � la soumission du formulaire
            const recaptchaInput = form.find('.' + recaptchaInputName);
            const tokenInput = createInput(token);
            if (!recaptchaInput.length) {
              form.append(tokenInput);
            } else {
              recaptchaInput.replaceWith(tokenInput);
            }
          })
          .then(function() {
            // Soumission du formulaire
            e.currentTarget.submit();
          });
      });
    });
  }
};
